module.exports = __webpack_public_path__ + "img/DigitalServices.807b4b3b.svg";